import React from 'react'
import {AiOutlineCopyright} from 'react-icons/ai'
import {AiOutlineMail} from 'react-icons/ai'
import {RiLinkedinFill, RiInstagramFill, RiFacebookFill,RiPhoneFill, RiMapPinFill, RiMailFill} from 'react-icons/ri'
import { Link } from 'react-router-dom'


const Footer = () => {
  return (
    <div id='contact' className='flex w-full items-center font-Lato container mx-auto px-4 justify-center bg-[#f19a60] text-white'>
        <div className='flex flex-col items-center justify-center'>
            
            <div className="mt-8 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
<p className='text-2xl font-bold my-1'>
                  Stay Social
                </p>
                <p className=' font-medium my-1'>
                  Follow Us On Our Social Handles

                </p>
                <p style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <a href='https://www.instagram.com/bdk_travelseducation?igsh=dDhudHV4bnZvdmNo&utm_source=qr' target={'_blank'} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <RiInstagramFill className=' hover:scale-125 duration-300' size={25} />
              </a>

               <a href='https://www.instagram.com/bdk_travelseducation?igsh=dDhudHV4bnZvdmNo&utm_source=qr' target={'_blank'}  style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <RiFacebookFill className=' hover:scale-125 duration-300' size={25} />
              </a>

          <a href='https://www.https://ng.linkedin.com/in/blessed-don-kate-logistics-travel-and-edu-869905214' target={'_blank'} style={{ display: "flex", alignItems: "center", gap: "6px" }} >
              <RiLinkedinFill className=' hover:scale-125 duration-300' size={25} />
              </a>
              </p>

          </div>

            <div>
<p className=' text-2xl font-bold my-1'>
                  Our contacts
                </p>
                
                <a href='tel:+2349066698256' style={{ display: "flex", alignItems: "center", gap: "6px" }}> <RiPhoneFill size={25} className=' hover:scale-125 duration-300' /> +2349066698256 <br />
              </a>
              <a href='mailto:bdktravelseducation@gmail.com' style={{ display: "flex", alignItems: "center", gap: "6px" }}> <RiMailFill size={25} className=' hover:scale-125 duration-300' /> bdktravelseducation@gmail.com
              </a>
          </div>
 
 <div>
<p className='text-2xl font-bold my-1'>
                  Office address
                </p>
                
                <p style={{ display: "flex", alignItems: "center", gap: "6px" }}><RiMapPinFill className=' hover:scale-125 duration-300'  size={30}  />Suite 33, Dee Awwal Plaza, Michael Okpara Street, Wuse Zone 5, Abuja.</p>
          </div>
            </div>

           
              

               <hr className='w-full h-[1px] bg-white mt-3 mb-1' />
            <span className='flex items-center text-[12px] mt-5 md:text-xs font-medium mb-3'><AiOutlineCopyright/>2024 by Blessed Don-Kate</span>
        </div>
    </div>
  )
}

export default Footer